import { Helmet } from 'react-helmet';

export const PageUpdate = () => {
  return (
    <>
      <Helmet>
        <title>고객을 끌어오는 구글 애널리틱스4</title>
      </Helmet>
      <div>
        <h1>고객을 끌어오는 구글 애널리틱스4의 업데이트 내역을 안내합니다.</h1>
        <br />
        <br />
        <a href="https://blog.naver.com/appifystudio/222841170236" target="_blank">33쪽, 구글 애널리틱스 체험하기 내용이 업데이트되었습니다.</a>
        <br />
        <br />
        <a href="https://blog.naver.com/appifystudio/222850654117" target="_blank">41쪽, 데모 계정 연동 방법이 변경되었습니다.</a>
      </div>
    </>
  )
}
